import Vue from "vue";
import Router from "vue-router";

// Containers
const DefaultContainer = () => import("@/containers/DefaultContainer");

// Views
const Dashboard = () => import("@/views/Dashboard");

// Views - Pages
const Page404 = () => import("@/views/pages/Page404");
const Page500 = () => import("@/views/pages/Page500");
const Login = () => import("@/views/pages/Login");
const Logout = () => import("@/views/pages/Logout");
const ForgotPasswd = () => import("@/views/pages/ForgotPasswd");

// Views
const AdminEE = () => import("@/views/pages/AdminEE");
const AdminES = () => import("@/views/pages/AdminES");
const MonCompte = () => import("@/views/pages/MonCompte");

// Users
const Users = () => import("@/views/users/Users");
const User = () => import("@/views/users/User");

const Browser = () => import("@/views/pages/Browser");

/**************** Administration générale ************/
const AccueilAdmin = () => import("@/views/administration/Accueil");
const RulesManagement = () => import("@/views/administration/droits/GestionDroit");
const GestionProfils = () => import("@/views/administration/profils/GestionProfil");
const GestionUsers = () => import("@/views/administration/GestionUsers");
const EditUser = () => import("@/views/administration/users/Edit");
const CreateUser = () => import("@/views/administration/users/Create");
const CreateProfil = () => import("@/views/administration/profils/Create");
const EditProfil = () => import("@/views/administration/profils/Edit");
const EditDroit = () => import("@/views/administration/droits/Edit");
const AddDroit = () => import("@/views/administration/droits/Add");
const ChangePasswd = () => import("@/views/administration/users/ChangePasswd");
const GestionTraitement = () => import("@/views/administration/traitements/GestionTraitement");
const CreateTraitement = () => import("@/views/administration/traitements/Create");
const EditTraitement = () => import("@/views/administration/traitements/Edit");
const AttachStatut = () => import("@/views/administration/traitements/AttachStatut");

const GestionRapport = () => import("@/views/administration/rapports/GestionRapport");
const CreateRapport = () => import("@/views/administration/rapports/Create");
const EditRapport = () => import("@/views/administration/rapports/Edit");

// const CategorieStatus = () => import("@/views/administration/GestionCategorie");
const CreateCategorie = () => import("@/views/administration/categories/Create");
const EditCategorie = () => import("@/views/administration/categories/Edit");
const GestionStatus = () => import("@/views/administration/GestionCategorieStatus");
const CreateStatus = () => import("@/views/administration/status/Create");
const EditStatus = () => import("@/views/administration/status/Edit");

// const Documents = () => import("@/views/administration/bibliotheque/documents/List");
// const AddDocument = () => import("@/views/administration/bibliotheque/documents/Create");
// const EditDocument = () => import("@/views/administration/bibliotheque/documents/Edit");
// const Bibliotheque = () => import("@/views/administration/bibliotheque/List");
// const AddBibliotheque = () => import("@/views/administration/bibliotheque/Create");
// const EditBibliotheque = () => import("@/views/administration/bibliotheque/Edit");
// const DocumentsLibrary = () => import("@/views/administration/bibliotheque/DocumentsList");

// const Categories = () => import("@/views/administration/bibliotheque/categories/List");
// const AddCategory = () => import("@/views/administration/bibliotheque/categories/Create");
// const EditCategory = () => import("@/views/administration/bibliotheque/categories/Edit");

const GestionEquipes = () => import("@/views/administration/GestionEquipes");
// Paramétrage tables transverses
const DelegationCommerciale = () => import("@/views/administration/tables/DelegationCommerciale");
const DelegationTerritoriale = () => import("@/views/administration/tables/DelegationTerritoriale");
const SegmentCommercial = () => import("@/views/administration/tables/SegmentCommercial");
const StatusPrestij = () => import("@/views/administration/tables/StatusPrestij");
const CodePostal = () => import("@/views/administration/tables/CodePostal");

const TraceNavigation = () => import("@/views/administration/FilOperations");
/**************** FIN Administration générale ************/

/**************** Réception de mail ************/
const GestionBal = () => import("@/views/administration/gestionBals/GestionBal");
/**************** FIN Réception de mail ************/

/**************** Espace bénéficiaire ************/
const AccueilEB = () => import("@/views/espaceBeneficiaire/Accueil");

const Beneficiaires = () => import("@/views/espaceBeneficiaire/Beneficiaires");
const Contacts = () => import("@/views/espaceBeneficiaire/Contacts");
const AdminContacts = () => import("@/views/espaceBeneficiaire/AdminContacts");
const AddAdminContacts = () => import("@/views/espaceBeneficiaire/admin/contacts/add");
const EditAdminContacts = () => import("@/views/espaceBeneficiaire/admin/contacts/edit");

const AdminFaq = () => import("@/views/espaceBeneficiaire/AdminFaq");
const AddAdminFaq = () => import("@/views/espaceBeneficiaire/admin/faq/add");
const EditAdminFaq = () => import("@/views/espaceBeneficiaire/admin/faq/edit");

const Justificatifs = () => import("@/views/espaceBeneficiaire/justificatifs");
const Decomptes = () => import("@/views/espaceBeneficiaire/decomptes");
const Inscriptions = () => import("@/views/espaceBeneficiaire/Inscriptions");
const Actualites = () => import("@/views/espaceBeneficiaire/actualites");
const AddActualites = () => import("@/views/espaceBeneficiaire/actualites/add");
const EditActualites = () => import("@/views/espaceBeneficiaire/actualites/edit");

const Statistiques = () => import("@/views/espaceBeneficiaire/Statistiques");
const FaqStats = () => import("@/views/espaceBeneficiaire/FaqStats");
const ContactStats = () => import("@/views/espaceBeneficiaire/ContactStats");

const FicheBeneficiaire = () => import("@/views/espaceBeneficiaire/FicheBeneficiaire");
const FicheDossier = () => import("@/views/espaceBeneficiaire/justificatifs/ficheDossier");
const FicheContact = () => import("@/views/espaceBeneficiaire/contacts/ficheContact");
const EditActualiteBo = () => import("@/views/espaceBeneficiaire/actualitesBo/edit");

const EditEcheancier = () => import("@/views/espaceBeneficiaire/echeancier/edit");
/**************** FIN Espace bénéficiaire ************/

/*************** Espace Gestion *************/
const AccueilEspaceGestion = () => import("@/views/espaceGestion/Accueil");
const AdhesionEnLigne = () => import("@/views/espaceGestion/AdhesionEnLigne");
const ReceptionMail = () => import("@/views/espaceGestion/receptionMail/ReceptionMail");
const ShowMail = () => import("@/views/espaceGestion/receptionMail/ShowMail");
// Gestion des dossiers
const AccueilGestionDossier = () => import("@/views/espaceGestion/GestionDossier/Dashboard");
const ShowDossier = () => import("@/views/espaceGestion/GestionDossier/Dossier");
// Gestion des corbeilles
const AccueilBasket = () => import("@/views/espaceGestion/GestionCorbeille/Baskets");
// Paramétrage du dossier
const AccueilCanal = () => import("@/views/espaceGestion/ParametrageDossier/Canal");
const AccueilType = () => import("@/views/espaceGestion/ParametrageDossier/Type");
const AccueilSegment = () => import("@/views/espaceGestion/ParametrageDossier/Segment");
// Gestion des produits
const AccueilProduit = () => import("@/views/espaceGestion/Produits/FamilleProduit");
const TypeProduit = () => import("@/views/espaceGestion/Produits/Type/List");
const GammeProduit = () => import("@/views/espaceGestion/Produits/Gamme/List");
const FamilleProduit = () => import("@/views/espaceGestion/Produits/Famille/List");
/*************** FIN Espace Gestion *************/

const Sirens = () => import("@/views/espaceGestion/referentielClient/Sirens");
const FicheSiren = () => import("@/views/espaceGestion/referentielClient/FicheSiren");

/***************  Espace RPA *************/
const AccueilEspaceRPA = () => import("@/views/espaceRPA/Accueil");
const Reglements = () => import("@/views/espaceRPA/Reglements");
const CreateVirement = () => import("@/views/espaceRPA/reglements/CreateVirement");
const Soldes = () => import("@/views/espaceRPA/Soldes");
const Clotures = () => import("@/views/espaceRPA/Clotures");
const Mouvements = () => import("@/views/espaceRPA/Mouvements");
const ReferentielIBANSIREN = () => import("@/views/espaceRPA/ibanSiren/Referentiel");
const CreateIBANSIREN = () => import("@/views/espaceRPA/ibanSiren/Create");


/*************** FIN Espace RPA *************/

const ListeLivraisons = () => import("@/views/administration/livraisons/List");
const HistoVersions = () => import("@/views/administration/livraisons/HistoVersions");


/***************** Espace Employeur ***********/
const AccueilEspaceEmployeur = () => import("@/views/espaceEmployeur/Accueil");
const AffectationGrille = () => import("@/views/espaceEmployeur/AffectationGrille");
const Inscription = () => import("@/views/espaceEmployeur/Inscription");
const GenerateCodeAccess = () => import("@/views/espaceEmployeur/GenerateCodeAccess");
const AdminSearch = () => import("@/views/espaceEmployeur/AdminSearch");
const SiretSearch = () => import("@/views/espaceEmployeur/SiretSearch");

// const FichesEnCours = () => import("@/views/espaceEmployeur/ficheNiveau2/FichesEnCours");
// const Recherche = () => import("@/views/espaceEmployeur/ficheNiveau2/Recherche");
// const AddFiche = () => import("@/views/espaceEmployeur/ficheNiveau2/Add");
// const ShowFiche = () => import("@/views/espaceEmployeur/ficheNiveau2/Edit");
// const Domaines = () => import("@/views/espaceEmployeur/ficheNiveau2/Domaines");
// const DomaineEquipe = () => import("@/views/espaceEmployeur/ficheNiveau2/DomaineEquipe");

/***************** Espace Relation Client ***********/
const AccueilEspaceRC = () => import("@/views/espaceRelationClient/Accueil");

Vue.use(Router);

import { requireAuth, setCurrentSite } from "@/utils/auth";
import { rules, hasRule, espaceBeneficiaireRules as rulesEB, espaceGestionRules as rulesEspaceGestion, sites, extractionRules, espaceRPARules, espaceQualiteRules, espaceBibliothequeRules, espaceRCRules } from "@/utils/rulesHelper";

let router =  new Router({
  mode: "history",
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: "/password/forgot",
      name: "ForgotPasswd",
      meta: {requiresAuth: false},
      component: ForgotPasswd
    },
    {
      path: "/login",
      name: "Login",
      meta: {requiresAuth: false},
      component: Login
    },
    {
      path: "/logout",
      name: "Logout",
      meta: {requiresAuth: false},
      component: Logout
    },
    {
      path: "/browser",
      name: "Browser",
      meta: {requiresAuth: false},
      component: Browser
    },
    {
      path: "/",
      component: DefaultContainer,
      beforeEnter: requireAuth,
      // meta: {requiresAuth: true},
      redirect: "/espaces",
      children: [
        {
          path: "/espaces",
          name: "Accueil",
          meta: {cssClass:'accueil', site: sites.SETTINGS, title: 'BO - Page accueil'},
          component: Dashboard
        },
        {
          path: "/last-versions/list",
          name: "Histo livraisons",
          meta: {cssClass:'accueil', site: sites.SETTINGS, title: 'BO - Page accueil'},
          component: HistoVersions
        },
        {
          path: "/espace-beneficiaire/accueil",
          name: "Administration Espace Bénéficiaire",
          meta: {cssClass:'espace-beneficiaire', site: sites.EB, title: 'BO - Espace bénéficiaire'},
          component: AccueilEB
        },
        {
          path: "/espace-beneficiaire/accueil/actualitesBo/edit/:id",
          name: "Modification actualité Back-Office",
          meta: {cssClass:'espace-beneficiaire', site: sites.EB, title: 'BO - Espace bénéficiaire'},
          component: EditActualiteBo
        },
        {
          path: "/admin/ee",
          name: "adminEE",
          meta: {cssClass:'espace-employeur', site: sites.EEM, title: 'BO - EE'},
          component: AdminEE
        },
        {
          path: "/admin/es",
          name: "adminES",
          meta: {cssClass:'espace-salarie', site: sites.ESAL, title: 'BO - ES'},
          component: AdminES
        },
        {
          path: "espace-gestion",
          redirect: "/espace-gestion/accueil",
          name: "Espace Gestion",
          meta: {title: 'BO - Espace Gestion'},
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "/espace-gestion/accueil",
              name: "Accueil Espace Gestion",
              meta: {cssClass:'espace-gestion', site: sites.EG, title: 'Accueil espace gestion'},
              component: AccueilEspaceGestion
            },
            {
              path: "/espace-gestion/code-barre-dbco",
              name: "Gestion des codes barre DBCO",
              meta: {cssClass:'espace-gestion', site: sites.EG, title: 'Gestion des codes barre'},
              component: () => import("@/views/espaceGestion/CodeBarre/CodeBarreDbco")
            },
            {
              path: "/espace-gestion/relance-deces",
              name: "Gestion cron relance deces",
              meta: {cssClass:'espace-gestion', site: sites.EG, title: 'Gestion cron relance décès'},
              component: () => import("@/views/espaceGestion/CronRelanceDeces/RelanceDeces")
            },
            {
              path: "/espace-gestion/listing",
              name: "Gestion des listing",
              meta: {cssClass:'espace-gestion', site: sites.EG, title: 'Gestion des listing'},
              component: () => import("@/views/espaceGestion/Listing/listing")
            },
            {
              path: "ael",
              name: "Adhésion en ligne",
              redirect: "ael",
              meta: {title: 'BO - EG - Adhesion en ligne'},
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              children: [
                {
                  path: "",
                  name: "Accueil Adhésion en ligne",
                  meta: {cssClass: 'espace-gestion', rule: rulesEB.ACCESS_AEL, site: sites.EG, title: 'BO - EG - Adhésion en ligne'},
                  component: AdhesionEnLigne
                }
              ]
            },
            {
              path: "mail",
              name: "Réception Mail",
              redirect: "mail",
              meta: {title: 'Réception des mails'},
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              children: [
                {
                  path: "",
                  name: "Liste des mails",
                  meta: {cssClass: 'espace-gestion', rule: rulesEspaceGestion.ACCESS_RECEPTION_MAIL, site: sites.EG, title: 'Réception des mails'},
                  component: ReceptionMail
                },
                {
                  path: "show/:id",
                  name: "Réception des mails",
                  meta: {cssClass: 'espace-gestion', rule: rulesEspaceGestion.ACCESS_RECEPTION_MAIL, site: sites.EG, title: 'Visualisation du mail'},
                  component: ShowMail
                }
              ]
            },
            {
              path: "corbeille",
              name: "Gestion corbeille",
              redirect: "accueil",
              meta: {title: 'Gestion des corbeilles'},
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              children: [
                {
                  path: "accueil",
                  name: "accueil corbeille",
                  meta: {cssClass: 'espace-gestion', rule: rulesEspaceGestion.CAN_ACCESS_GESTION_BASKET_DOSSIER, site: sites.EG, title: 'Gestion des corbeilles'},
                  component: AccueilBasket
                },
                // {
                //   path: "show/:id",
                //   name: "fiche dossier",
                //   meta: {cssClass: 'espace-gestion', rule: rulesEspaceGestion.ACCESS_GESTION_DOSSIER, site: sites.EG, title: 'Visualisation du dossier'},
                //   component: ShowDossier
                // }
              ]
            },
            {
              path: "dossier",
              name: "Gestion des dossiers",
              redirect: "dossier/dashboard",
              meta: {title: 'Gestion des dossiers'},
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              children: [
                {
                  path: "dashboard",
                  name: "Tableau de bord des dossiers",
                  meta: {cssClass: 'espace-gestion', rule: rulesEspaceGestion.ACCESS_GESTION_DOSSIER, site: sites.EG, title: 'Tableau de bord des dossiers'},
                  component: AccueilGestionDossier
                },
                {
                  path: "show/:id",
                  name: "fiche dossier",
                  meta: {cssClass: 'espace-gestion', rule: rulesEspaceGestion.ACCESS_GESTION_DOSSIER, site: sites.EG, title: 'Visualisation du dossier'},
                  component: ShowDossier
                }
              ]
            },
            {
              path: "parametrage",
              name: "Paramétrage Dossier",
              redirect: "canal",
              meta: {title: 'Gestion des dossiers'},
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              children: [
                {
                  path: "canal",
                  name: "Gestion des canaux",
                  meta: {cssClass: 'accueil', rule: rulesEspaceGestion.CAN_CONFIGURE_DOSSIER, site: sites.SETTINGS, title: 'Paramétrage des canaux'},
                  component: AccueilCanal
                },
                {
                  path: "type",
                  name: "Gestion des types",
                  meta: {cssClass: 'accueil', rule: rulesEspaceGestion.CAN_CONFIGURE_DOSSIER, site: sites.SETTINGS, title: 'Paramétrage des types'},
                  component: AccueilType
                },
                {
                  path: "segment",
                  name: "Gestion des segments",
                  meta: {cssClass: 'accueil', rule: rulesEspaceGestion.CAN_CONFIGURE_DOSSIER, site: sites.SETTINGS, title: 'Paramétrage des segments'},
                  component: AccueilSegment
                },
                {
                  path: "type-pj",
                  name: "Gestion des types de pj",
                  meta: {cssClass:'accueil', site: sites.SETTINGS, title: 'Types de pièces jointes'},
                  component: () => import("@/views/espaceGestion/ParametrageDossier/typePj")
                },
              ]
            },
            {
              path: "sirens",
              name: "Fiche SIREN",
              redirect: "sirens/liste",
              meta: {title: 'BO - EG - Fiche SIREN'},
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              children: [
                {
                  path: "liste",
                  name: "Liste des Sirens",
                  meta: {cssClass: 'espace-gestion', rule: rulesEspaceGestion.CAN_ACCESS_FICHE_SIREN, site: sites.EG, title: 'BO - EG - Liste des SIREN'},
                  component: Sirens
                },
                {
                  path: "fiche/:siren",
                  name: "Fiche du siren",
                  meta: {cssClass: 'espace-gestion', rule: rulesEspaceGestion.CAN_ACCESS_FICHE_SIREN, site: sites.EG, title: 'BO - EG - Fiche SIREN'},
                  component: FicheSiren
                }
              ]
            },
            {
              path: "groupes-siren",
              name: "Gestion des groupes SIREN",
              redirect: "groupes-siren/list",
              meta: {title: 'Espace Gestion - Groupes SIREN', rule: rulesEspaceGestion.CAN_ACCESS_GROUP_SIREN},
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              children: [
                {
                  path: "list",
                  name: "Liste des groupes SIREN",
                  meta: {cssClass:'espace-gestion', site: sites.EG, title: 'Espace Gestion - Groupes SIREN', rule: rulesEspaceGestion.CAN_ACCESS_GROUP_SIREN},
                  component: () => import("@/views/espaceGestion/GroupeSiren/GestionGroupesSiren")
                },
                {
                  path: "edit/:id",
                  name: "Modifier un groupe SIREN",
                  meta: {cssClass:'espace-gestion', site: sites.EG, title: 'Espace Gestion - Groupes SIREN', rule: rulesEspaceGestion.CAN_ACCESS_GROUP_SIREN},
                  component: () => import("@/views/espaceGestion/GroupeSiren/Detail")
                },
                {
                  path: "add",
                  name: "Créer un groupe SIREN",
                  meta: {cssClass:'espace-gestion', site: sites.EG, title: 'Espace Gestion - Groupes SIREN', rule: rulesEspaceGestion.CAN_MANAGE_GROUP_SIREN},
                  component: () => import("@/views/espaceGestion/GroupeSiren/Add")
                },
              ]
            },
            {
              path: "maj-prestij-siren",
              name: "MAJ Statut Prest'IJ SIREN en masse",
              meta: {cssClass:'espace-gestion', site: sites.EG, title: 'Espace Gestion - MAJ Statut Prest\'IJ SIREN', rule: rulesEspaceGestion.CAN_CHANGE_PREFERENCE_PRESTIJ_MASSE},
              component: () => import("@/views/espaceGestion/referentielClient/MajPrestijMasse")
            },
            {
              path: "equipes",
              name: "Equipes Gestion",
              redirect: "equipes/list",
              meta: {title: 'Administration - Equipes'},
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              children: [
                {
                  path: "list",
                  name: "Gestion des équipes",
                  meta: {cssClass:'espace-gestion', rule: rulesEspaceGestion.ACCESS_ADMIN_EQUIPES, site: sites.EG, title: 'Espace Gestion - Gestion Equipes'},
                  component: GestionEquipes
                },
              ]
            },
            {
              path: "consignes-produit",
              name: "Consignes produit",
              redirect: "consignes-produit/list",
              meta: {cssClass: 'espace-gestion', rule: rulesEspaceGestion.CAN_MANAGE_CONSIGNES, site: sites.EG, title: 'Consignes produit'},
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              children: [
                {
                  path: "list",
                  name: "Liste des consignes",
                  meta: {cssClass:'espace-gestion', rule: rulesEspaceGestion.CAN_MANAGE_CONSIGNES, site: sites.EG, title: 'Consignes Produits'},
                  component: () => import("@/views/espaceGestion/consignes/produits/List")
                },
                {
                  path: "edit/:id",
                  name: "Modifier une consigne produit",
                  meta: {cssClass:'espace-gestion', rule: rulesEspaceGestion.CAN_MANAGE_CONSIGNES, site: sites.EG, title: 'Consignes Produits'},
                  component: () => import("@/views/espaceGestion/consignes/produits/Edit")
                },
                {
                  path: "add",
                  name: "Créer une consigne produit",
                  meta: {cssClass:'espace-gestion', rule: rulesEspaceGestion.CAN_MANAGE_CONSIGNES, site: sites.EG, title: 'Consignes Produits'},
                  component: () => import("@/views/espaceGestion/consignes/produits/Add")
                },
              ]
            },
            {
              path: "consignes-blocage",
              name: "Consignes blocage",
              redirect: "consignes-blocage/list",
              meta: {cssClass: 'espace-gestion', rule: rulesEspaceGestion.CAN_MANAGE_CONSIGNES, site: sites.EG, title: 'Consignes blocage'},
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              children: [
                {
                  path: "list",
                  name: "Liste des consignes blocage",
                  meta: {cssClass:'espace-gestion', rule: rulesEspaceGestion.CAN_MANAGE_CONSIGNES, site: sites.EG, title: 'Consignes Blocages'},
                  component: () => import("@/views/espaceGestion/consignes/blocages/List")
                },
                {
                  path: "edit/:id",
                  name: "Modifier une consigne blocage",
                  meta: {cssClass:'espace-gestion', rule: rulesEspaceGestion.CAN_MANAGE_CONSIGNES, site: sites.EG, title: 'Consignes Blocages'},
                  component: () => import("@/views/espaceGestion/consignes/blocages/Edit")
                },
                {
                  path: "add",
                  name: "Créer une consigne blocage",
                  meta: {cssClass:'espace-gestion', rule: rulesEspaceGestion.CAN_MANAGE_CONSIGNES, site: sites.EG, title: 'Consignes Blocages'},
                  component: () => import("@/views/espaceGestion/consignes/blocages/Add")
                },
              ]
            },
            {
              path: "consignes-segment",
              name: "Consignes segment",
              redirect: "consignes-segment/list",
              meta: {cssClass: 'espace-gestion', rule: rulesEspaceGestion.CAN_MANAGE_CONSIGNES, site: sites.EG, title: 'Consignes segment'},
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              children: [
                {
                  path: "list",
                  name: "Liste des consignes par segment",
                  meta: {cssClass:'espace-gestion', rule: rulesEspaceGestion.CAN_MANAGE_CONSIGNES, site: sites.EG, title: 'Consignes segment'},
                  component: () => import("@/views/espaceGestion/consignes/segment/List")
                },
                {
                  path: "edit",
                  name: "Modifier une consigne segment",
                  meta: {cssClass:'espace-gestion', rule: rulesEspaceGestion.CAN_MANAGE_CONSIGNES, site: sites.EG, title: 'Consignes segment'},
                  component: () => import("@/views/espaceGestion/consignes/segment/Edit")
                },
              ]
            },
            {
              path: "consignes-siren",
              name: "Consignes siren",
              redirect: "consignes-siren/list",
              meta: {cssClass: 'espace-gestion', rule: rulesEspaceGestion.CAN_MANAGE_CONSIGNES, site: sites.EG, title: 'Consignes siren'},
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              children: [
                {
                  path: "list",
                  name: "Liste des consignes par siren",
                  meta: {cssClass:'espace-gestion', rule: rulesEspaceGestion.CAN_MANAGE_CONSIGNES, site: sites.EG, title: 'Consignes siren'},
                  component: () => import("@/views/espaceGestion/consignes/siren/List")
                },
                {
                  path: "edit",
                  name: "Modifier une consigne siren",
                  meta: {cssClass:'espace-gestion', rule: rulesEspaceGestion.CAN_MANAGE_CONSIGNES, site: sites.EG, title: 'Consignes siren'},
                  component: () => import("@/views/espaceGestion/consignes/siren/Edit")
                },
              ]
            },
            {
              path: "consignes-nir",
              name: "Consignes NIR",
              redirect: "consignes-nir/list",
              meta: {cssClass: 'espace-gestion', rule: rulesEspaceGestion.CAN_MANAGE_CONSIGNES, site: sites.EG, title: 'Consignes nir'},
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              children: [
                {
                  path: "list",
                  name: "Liste des consignes par nir",
                  meta: {cssClass:'espace-gestion', rule: rulesEspaceGestion.CAN_MANAGE_CONSIGNES, site: sites.EG, title: 'Consignes nir'},
                  component: () => import("@/views/espaceGestion/consignes/nir/List")
                },
                {
                  path: "edit",
                  name: "Modifier une consigne nir",
                  meta: {cssClass:'espace-gestion', rule: rulesEspaceGestion.CAN_MANAGE_CONSIGNES, site: sites.EG, title: 'Consignes nir'},
                  component: () => import("@/views/espaceGestion/consignes/nir/Edit")
                },
              ]
            },
            {
              path: "famille-produit",
              name: "Famille Produit",
              redirect: "famille-produit/list",
              meta: {cssClass: 'espace-gestion', rule: rulesEspaceGestion.CAN_ACCESS_PRODUIT, site: sites.EG, title: 'Famille Produit'},
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              children: [
                {
                  path: "list",
                  name: "Gestion des produits",
                  meta: {cssClass:'espace-gestion', rule: rulesEspaceGestion.CAN_ACCESS_PRODUIT, site: sites.EG, title: 'Gestion des produits'},
                  component: AccueilProduit
                },
                {
                  path: "add",
                  name: "Créer un produit",
                  meta: {cssClass:'espace-gestion', rule: rulesEspaceGestion.CAN_MANAGE_PRODUIT, site: sites.EG, title: 'Produit'},
                  component: () => import("@/views/espaceGestion/Produits/Add")
                },
                {
                  path: "qualification",
                  name: "Qualification produits",
                  meta: {cssClass:'espace-gestion', rule: rulesEspaceGestion.CAN_MANAGE_PRODUIT, site: sites.EG, title: 'Gestion des produits'},
                  component: () => import("@/views/espaceGestion/Produits/Qualification")
                },
              ]
            },
            {
              path: "produit/gestion-type",
              name: "produit/gestion-type",
              redirect: "produit/gestion-type/list",
              meta: {cssClass: 'espace-gestion', rule: rulesEspaceGestion.CAN_ACCESS_PRODUIT, site: sites.EG, title: 'Gestion Types Produit'},
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              children: [
                {
                  path: "list",
                  name: "Gestion Types produit",
                  meta: {cssClass:'espace-gestion', rule: rulesEspaceGestion.CAN_ACCESS_PRODUIT, site: sites.EG, title: 'Gestion Types Produit'},
                  component: TypeProduit
                },
                {
                  path: "add",
                  name: "Créer un type produit",
                  meta: {cssClass:'espace-gestion', rule: rulesEspaceGestion.CAN_MANAGE_PRODUIT, site: sites.EG, title: 'Type Produit'},
                  component: () => import("@/views/espaceGestion/Produits/Type/Add")
                },
                {
                  path: "edit/:id",
                  name: "Modifier un type produit",
                  meta: {cssClass:'espace-gestion', rule: rulesEspaceGestion.CAN_MANAGE_PRODUIT, site: sites.EG, title: 'Type Produit'},
                  component: () => import("@/views/espaceGestion/Produits/Type/Edit")
                },
              ]
            },
            {
              path: "produit/gestion-gamme",
              name: "produit/gestion-gamme",
              redirect: "produit/gestion-gamme/list",
              meta: {cssClass: 'espace-gestion', rule: rulesEspaceGestion.CAN_ACCESS_PRODUIT, site: sites.EG, title: 'Gestion Gammes Produit'},
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              children: [
                {
                  path: "list",
                  name: "Gestion Gammes produit",
                  meta: {cssClass:'espace-gestion', rule: rulesEspaceGestion.CAN_ACCESS_PRODUIT, site: sites.EG, title: 'Gestion Gammes Produit'},
                  component: GammeProduit
                },
                {
                  path: "add",
                  name: "Créer une gamme produit",
                  meta: {cssClass:'espace-gestion', rule: rulesEspaceGestion.CAN_MANAGE_PRODUIT, site: sites.EG, title: 'Gamme Produit'},
                  component: () => import("@/views/espaceGestion/Produits/Gamme/Add")
                },
                {
                  path: "edit/:id",
                  name: "Modifier une gamme produit",
                  meta: {cssClass:'espace-gestion', rule: rulesEspaceGestion.CAN_MANAGE_PRODUIT, site: sites.EG, title: 'Gamme Produit'},
                  component: () => import("@/views/espaceGestion/Produits/Gamme/Edit")
                },
              ]
            },
            {
              path: "produit/gestion-famille",
              name: "produit/gestion-famille",
              redirect: "produit/gestion-famille/list",
              meta: {cssClass: 'espace-gestion', rule: rulesEspaceGestion.CAN_ACCESS_PRODUIT, site: sites.EG, title: 'Gestion Familles Produit'},
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              children: [
                {
                  path: "list",
                  name: "Gestion Familles produit",
                  meta: {cssClass:'espace-gestion', rule: rulesEspaceGestion.CAN_ACCESS_PRODUIT, site: sites.EG, title: 'Gestion Familles Produit'},
                  component: FamilleProduit
                },
                {
                  path: "add",
                  name: "Créer une famille produit",
                  meta: {cssClass:'espace-gestion', rule: rulesEspaceGestion.CAN_MANAGE_PRODUIT, site: sites.EG, title: 'Famille Produit'},
                  component: () => import("@/views/espaceGestion/Produits/Famille/Add")
                },
                {
                  path: "edit/:id",
                  name: "Modifier une famille produit",
                  meta: {cssClass:'espace-gestion', rule: rulesEspaceGestion.CAN_MANAGE_PRODUIT, site: sites.EG, title: 'Famille Produit'},
                  component: () => import("@/views/espaceGestion/Produits/Famille/Edit")
                },
              ]
            },
            {
              path: "produit/gestion-grille",
              name: "produit/gestion-grille",
              redirect: "produit/gestion-grille/list",
              meta: {cssClass: 'espace-gestion', rule: rulesEspaceGestion.CAN_ACCESS_PRODUIT, site: sites.EG, title: 'Gestion Grille Salaire'},
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              children: [
                {
                  path: "list",
                  name: "Gestion Grilles Salaire",
                  meta: {cssClass:'espace-gestion', rule: rulesEspaceGestion.CAN_ACCESS_PRODUIT, site: sites.EG, title: 'Gestion Grille Salaire'},
                  component: () => import("@/views/espaceGestion/Produits/Grille/List")
                },
                {
                  path: "add",
                  name: "Créer une grille de salaire",
                  meta: {cssClass:'espace-gestion', rule: rulesEspaceGestion.CAN_MANAGE_PRODUIT, site: sites.EG, title: 'Grille Salaire'},
                  component: () => import("@/views/espaceGestion/Produits/Grille/Add")
                },
                {
                  path: "edit/:id",
                  name: "Modifier une grille de salaire",
                  meta: {cssClass:'espace-gestion', rule: rulesEspaceGestion.CAN_MANAGE_PRODUIT, site: sites.EG, title: 'Grille Salaire'},
                  component: () => import("@/views/espaceGestion/Produits/Grille/Edit")
                },
              ]
            },
            {
              path: "actualite",
              name: "Actualité",
              redirect: "actualite/list",
              meta: {title: 'Actualité'},
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              children: [
                {
                  path: "list",
                  name: "Liste d'actualité",
                  meta: {cssClass:'espace-gestion', site: sites.EG, title: 'Actualité', rule: rulesEspaceGestion.CAN_MANAGE_ACTUALITE},
                  component: () => import("@/views/espaceGestion/Actualite/List")
                },
                {
                  path: "details/:id",
                  name: "Détail de l'actualité",
                  meta: {cssClass:'espace-gestion', site: sites.EG, title: 'Actualité', rule: rulesEspaceGestion.CAN_ACCESS_ACTUALITE},
                  component: () => import("@/views/espaceGestion/Actualite/Edit")
                },
                {
                  path: "add",
                  name: "Créer une actualité espace gestion",
                  meta: {cssClass:'espace-gestion', site: sites.EG, title: 'Actualité', rule: rulesEspaceGestion.CAN_MANAGE_ACTUALITE},
                  component: () => import("@/views/espaceGestion/Actualite/Add")
                },
              ]
            },
          {
              path: "module-prev",
              name: "Module Prev",
              //redirect: "consignes-segment/list",
              meta: {cssClass: 'espace-gestion', rule: rulesEspaceGestion.CAN_MANAGE_ACTUALITE, site: sites.EG, title: 'Module prev'},
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              children: [
                {
                  path: "historique-integration",
                  name: "Historique des intégrations NSI",
                  meta: {cssClass:'espace-gestion', site: sites.EG, title: 'Historique des intégrations NSI'},
                  component: () => import("@/views/espaceGestion/ModulePrev/HistoriqueIntegration")
                },
                {
                  path: "chargements",
                  name: "Module d'import des Retours NSI",
                  meta: {cssClass:'espace-gestion', site: sites.EG, title: 'Module d\'import des Retours NSI'},
                  component: () => import("@/views/espaceGestion/ModulePrev/Chargements")
                },
                {
                  path: "rapport/:id",
                  name: "Erreurs de chargement Module Prev",
                  meta: {cssClass:'espace-gestion', site: sites.EG, title: 'Chargement Module Prev'},
                  component: () => import("@/views/espaceGestion/ModulePrev/rapportChargement")
                },
                {
                  path: "script-opc-purge-bpij",
                  name: "Script OPC purge BPIJ",
                  meta: {cssClass:'espace-gestion', site: sites.EG, title: 'Script purge BPIJ'},
                  component: () => import("@/views/espaceGestion/ModulePrev/ScriptOpcPurge")
                }
              ]
            },
            {
              path: "extractions",
              name: "Extractions",
              redirect: "extractions/list",
              meta: {title: 'Extractions'},
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              children: [
                {
                  path: "list",
                  name: "Extractions et Synthèses",
                  meta: {cssClass:'espace-gestion', site: sites.EG, title: 'Extractions', rule: rulesEspaceGestion.CAN_ACCESS_EXTRACTIONS},
                  component: () => import("@/views/espaceGestion/Extractions/List")
                },
                {
                  path: "synthese-produit",
                  name: "Synthèse par produit",
                  meta: {cssClass:'espace-gestion', site: sites.EG, title: 'Synthèse par produit', rule: extractionRules.EXTRACT_PORTEFEUILLE_PRODUIT},
                  component: () => import("@/views/espaceGestion/Extractions/SyntheseProduit")
                },
                {
                  path: "synthese-structure",
                  name: "Synthèse par structure",
                  meta: {cssClass:'espace-gestion', site: sites.EG, title: 'Synthèse par structure', rule: extractionRules.EXTRACT_PORTEFEUILLE_TAILLE},
                  component: () => import("@/views/espaceGestion/Extractions/SyntheseStructure")
                },
                {
                  path: "synthese-sirh",
                  name: "Synthèse par sirh",
                  meta: {cssClass:'espace-gestion', site: sites.EG, title: 'Synthèse par sirh', rule: extractionRules.EXTRACT_PORTEFEUILLE_SIRH},
                  component: () => import("@/views/espaceGestion/Extractions/SyntheseSirh")
                },
                {
                  path: "anomalie-siren-nic",
                  name: "Liste des SIREN et NIC en anomalie",
                  meta: {cssClass:'espace-gestion', site: sites.EG, title: 'Liste des SIREN et NIC en anomalie', rule: extractionRules.EXTRACT_ANOMALIES_SIREN_NIC},
                  component: () => import("@/views/espaceGestion/Extractions/AnomalieSirenNic")
                },
                {
                  path: "anomalie-souscripteur",
                  name: "Liste des Souscripteurs Multiples",
                  meta: {cssClass:'espace-gestion', site: sites.EG, title: 'Liste des Souscripteurs Multiples', rule: extractionRules.EXTRACT_ANOMALIES_SOUSCRIPTEURS_MULTIPLES},
                  component: () => import("@/views/espaceGestion/Extractions/AnomalieSouscripteur")
                },
                {
                  path: "anomalie-produit",
                  name: "Liste des Produits en anomalie",
                  meta: {cssClass:'espace-gestion', site: sites.EG, title: 'Liste des Produits en anomalie', rule: extractionRules.EXTRACT_ANOMALIES_PRODUITS},
                  component: () => import("@/views/espaceGestion/Extractions/AnomalieProduit")
                },
                {
                  path: "extraction-saisie",
                  name: "Extraction statistiques BQC par date",
                  meta: {cssClass:'espace-gestion', site: sites.EG, title: 'Extraction statistiques BQC par date', rule: extractionRules.EXTRACT_SAISIES_DOSSIERS},
                  component: () => import("@/views/espaceGestion/Extractions/ExtractionSaisieParDate")
                },
                {
                  path: "extraction-saisie-rgpd",
                  name: "Extraction statistiques BQC par date (RGPD Compliant)",
                  meta: {cssClass:'espace-gestion', site: sites.EG, title: 'Extraction statistiques BQC par date (RGPD Compliant)', rule: extractionRules.EXTRACT_SAISIES_DOSSIERS_RGPD},
                  component: () => import("@/views/espaceGestion/Extractions/ExtractionSaisieRGPD")
                },
                {
                  path: "extraction-dossier-incident-rgpd",
                  name: "Extraction dossier avec incidents par date (RGPD Compliant)",
                  meta: {cssClass:'espace-gestion', site: sites.EG, title: 'Extraction dossier avec incidents par date (RGPD Compliant)', rule: extractionRules.EXTRACT_SAISIES_DOSSIERS_RGPD},
                  component: () => import("@/views/espaceGestion/Extractions/ExtractionDossierIncidentRGPD")
                },
                {
                  path: "extraction-dossier-journal-status",
                  name: "Extraction changement statut via journal",
                  meta: {cssClass:'espace-gestion', site: sites.EG, title: 'Extraction changement statut via journal', rule: extractionRules.EXTRACT_DOSSIERS_JOURNAL_STATUS},
                  component: () => import("@/views/espaceGestion/Extractions/ExtractionDossierJournalStatus")
                },
                {
                  path: "extraction-dossier-journal",
                  name: "Extraction journal des dossiers",
                  meta: {cssClass:'espace-gestion', site: sites.EG, title: 'Extraction changement statut via journal', rule: extractionRules.EXTRACT_DOSSIERS_JOURNAL},
                  component: () => import("@/views/espaceGestion/Extractions/ExtractionDossierJournal")
                },
                {
                  path: "extraction-dossier-produit-status",
                  name: "Extraction dossier par produit et statut",
                  meta: {cssClass:'espace-gestion', site: sites.EG, title: 'Extraction dossier par produit et statut', rule: extractionRules.EXTRACT_SAISIES_DOSSIERS_RGPD},
                  component: () => import("@/views/espaceGestion/Extractions/ExtractionDossierProduitStatus")
                },
                {
                  path: "extraction-dossier-dpc",
                  name: "Extraction dossier en DPC",
                  meta: {cssClass:'espace-gestion', site: sites.EG, title: 'Extraction dossier en DPC', rule: extractionRules.EXTRACT_DOSSIERS_DPC},
                  component: () => import("@/views/espaceGestion/Extractions/ExtractionDossierDpc")
                },
                {
                  path: "extraction-dossier-dbco",
                  name: "Extraction dossier DBCO",
                  meta: {cssClass:'espace-gestion', site: sites.EG, title: 'Extraction dossier DBCO', rule: extractionRules.EXTRACT_DOSSIERS_DBCO},
                  component: () => import("@/views/espaceGestion/Extractions/ExtractionDossierDbco")
                },
                {
                  path: "extraction-ar-courrier-dbco",
                  name: "Extraction AR courrier DBCO",
                  meta: {cssClass:'espace-gestion', site: sites.EG, title: 'Extraction AR courrier DBCO', rule: extractionRules.EXTRACT_AR_COURRIER_DBCO},
                  component: () => import("@/views/espaceGestion/Extractions/ExtractionArCourrierDbco")
                },
                {
                  path: "base-affiliation",
                  name: "Extraction de la base affiliation",
                  meta: {cssClass:'espace-gestion', site: sites.EG, title: 'Extraction de la base affiliation', rule: extractionRules.EXTRACT_BASE_AFFILIATION},
                  component: () => import("@/views/espaceGestion/Extractions/ExtractionAffiliation")
                },
                {
                  path: "base-affiliation-nic",
                  name: "Extraction de la base affiliation avec nic",
                  meta: {cssClass:'espace-gestion', site: sites.EG, title: 'Extraction de la base affiliation', rule: extractionRules.EXTRACT_BASE_AFFILIATION},
                  component: () => import("@/views/espaceGestion/Extractions/ExtractionAffiliationNic")
                },
                {
                  path: "declaration-at-cev",
                  name: "Declaration AT CeV",
                  meta: {cssClass:'espace-gestion', site: sites.EG, title: 'Declaration AT CeV', rule: extractionRules.EXTRACT_DECLARATION_AT_CEV},
                  component: () => import("@/views/espaceGestion/Extractions/DeclarationAtCev")
                },
                {
                  path: "user-atlas",
                  name: "Utilisateur ATLAS",
                  meta: {cssClass:'espace-gestion', site: sites.EG, title: 'Utilisateur ATLAS', rule: extractionRules.EXTRACT_USER_ATLAS},
                  component: () => import("@/views/espaceGestion/Extractions/UtilisateurAtlas")
                },
                {
                  path: "fiche-tel-dgpo",
                  name: "Fiche téléphonique Dgpo",
                  meta: {cssClass:'espace-gestion', site: sites.EG, title: 'Fiche téléphonique Dgpo', rule: extractionRules.EXTRACT_FICHE_TEL_DGPO},
                  component: () => import("@/views/espaceGestion/Extractions/FicheTelDgpo")
                },
                {
                  path: "chargement-bpij",
                  name: "Chargement BPIJ",
                  meta: {cssClass:'espace-gestion', site: sites.EG, title: 'Chargement BPIJ', rule: extractionRules.EXTRACT_CHARGEMENT_BPIJ},
                  component: () => import("@/views/espaceGestion/Extractions/ChargementBpij")
                },
                {
                  path: "ecarts-libelles-blocage",
                  name: "Liste des écarts entre libellés blocage",
                  meta: {cssClass:'espace-gestion', site: sites.EG, title: 'Liste des écarts entre libellés blocage', rule: extractionRules.EXTRACT_ANOMALIES_PRODUITS},
                  component: () => import("@/views/espaceGestion/Extractions/EcartsLibellesBlocage")
                },
                {
                  path: "dossier-reopen",
                  name: "Dossier ayant eu une réouverture",
                  meta: {cssClass:'espace-gestion', site: sites.EG, title: 'Dossier ayant eu une réouverture', rule: extractionRules.EXTRACT_DOSSIER_REOPEN},
                  component: () => import("@/views/espaceGestion/Extractions/DossierReopen")
                },
                {
                  path: "dossier-ja-n-1",
                  name: "Dossier JA N-1",
                  meta: {cssClass:'espace-gestion', site: sites.EG, title: 'Dossier avec JA N-1', rule: extractionRules.EXTRACT_DOSSIER_JA_N_1},
                  component: () => import("@/views/espaceGestion/Extractions/DossierJaN1")
                },
                {
                  path: "inval-ressource",
                  name: "Dossier Inval ressource",
                  meta: {cssClass:'espace-gestion', site: sites.EG, title: 'Dossier Inval ressource', rule: extractionRules.EXTRACT_DOSSIER_INVAL_RESOURCE},
                  component: () => import("@/views/espaceGestion/Extractions/DossierInvalRessource")
                },
              ]
            },
            {
              path: "assures",
              name: "Assurés",
              redirect: "assures/list",
              meta: {cssClass: 'espace-gestion', site: sites.EG, title: 'Assurés', rule: rulesEspaceGestion.CAN_ACCESS_ASSURES},
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              children: [
                {
                  path: "list",
                  name: "Liste des assurés",
                  meta: {cssClass:'espace-gestion', site: sites.EG, title: 'Assurés', rule: rulesEspaceGestion.CAN_ACCESS_ASSURES},
                  component: () => import("@/views/espaceGestion/Assures/List")
                },
                {
                  path: "fiche/:nir",
                  name: "Fiche assuré",
                  meta: {cssClass:'espace-gestion', site: sites.EG, title: 'Assurés', rule: rulesEspaceGestion.CAN_ACCESS_ASSURES},
                  component: () => import("@/views/espaceGestion/Assures/Fiche")
                },
              ]
            },
            {
              path: "chargement-prestij",
              name: "Chargement Prestij",
              redirect: "chargement-prestij/list",
              meta: {cssClass: 'espace-gestion', site: sites.EG, title: 'Chargement Prestij'},
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              children: [
                {
                  path: "list",
                  name: "Chargement Prestij list",
                  meta: {cssClass:'espace-gestion', site: sites.EG, title: 'Chargement Prestij'},
                  component: () => import("@/views/espaceGestion/chargementPrestij/List")
                },
                {
                  path: "erreurs/:id",
                  name: "Erreurs de chargement Prestij",
                  meta: {cssClass:'espace-gestion', site: sites.EG, title: 'Chargement Prestij'},
                  component: () => import("@/views/espaceGestion/chargementPrestij/erreurChargement")
                }
              ]
            },
            {
              path: "decomptes-ij",
              name: "Decomptes IJ",
              redirect: "decomptes-ij/list",
              meta: {cssClass: 'espace-gestion', site: sites.EG, title: 'Decomptes IJ'},
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              children: [
                {
                  path: "list",
                  name: "Decomptes IJ list",
                  meta: {cssClass:'espace-gestion', site: sites.EG, title: 'Decomptes IJ'},
                  component: () => import("@/views/espaceGestion/decomptesIJ/List")
                }
              ]
            },
            {
              path: "decomptes-invaldc",
              name: "Decomptes Inval/DC",
              redirect: "decomptes-invaldc/list",
              meta: {cssClass: 'espace-gestion', site: sites.EG, title: 'Decomptes Inval/DC'},
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              children: [
                {
                  path: "list",
                  name: "Decomptes Inval/DC list",
                  meta: {cssClass:'espace-gestion', site: sites.EG, title: 'Decomptes Inval/DC'},
                  component: () => import("@/views/espaceGestion/decomptesInvalDC/List")
                }
              ]
            },
            {
              path: "import-stock-dbco",
              name: "Import stock DBCO",
              redirect: "import-stock-dbco/upload",
              meta: {cssClass: 'espace-gestion', site: sites.EG, title: 'Reprise Stock DBCO'},
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              children: [
                {
                  path: "upload",
                  name: "Import stock DBCO chargement",
                  meta: {cssClass:'espace-gestion', site: sites.EG, title: 'Reprise Stock DBCO - chargement'},
                  component: () => import("@/views/espaceGestion/importDbco/chargement")
                }
              ]
            },
            {
              path: "action-masse-ocp",
              name: "Action en masse OCP",
              redirect: "action-masse-ocp/upload",
              meta: {cssClass: 'espace-gestion', site: sites.EG, title: 'Action en masse OCP', rule: rulesEspaceGestion.CAN_EXECUTE_OPC_PREV},
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              children: [
                {
                  path: "upload",
                  name: "Action en masse OCP chargement",
                  meta: {cssClass:'espace-gestion', site: sites.EG, title: 'Action en masse OCP - chargement', rule: rulesEspaceGestion.CAN_EXECUTE_OPC_PREV},
                  component: () => import("@/views/espaceGestion/ocp/chargement")
                },
              ]
            },
            {
              path: "desaffectation-masse-ocp",
              name: "Désaffectation en masse OCP",
              meta: {cssClass:'espace-gestion', site: sites.EG, title: 'Action en masse OCP - désaffectation', rule: rulesEspaceGestion.CAN_EXECUTE_DESAFFECTATION_MASSE_OCP},
              component: () => import("@/views/espaceGestion/ocp/desaffectation")
            },
            {
              path: "chargement-fichier-rentes-inval",
              name: "Historique chargement fichier rente inval",
              meta: {cssClass:'espace-gestion', site: sites.EG, title: 'Historique chargement fichier rente inval', rule: rulesEspaceGestion.CAN_ACCESS_IMPORT_RENTES},
              component: () => import("@/views/espaceGestion/Chargement/RentesInval/Historique")
            },
          ]
        },
        {
          path: "suivi-cotisations",
          redirect: "/suivi-cotisations/accueil",
          name: "Suivi des Cotisations",
          meta: {title: 'BO -  Suivi Cotisations'},
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "accueil",
              name: "Indicateurs",
              meta: {cssClass:'espace-rpa', site: sites.RPA, title: 'Cotisations - Indicateurs'},
              component: AccueilEspaceRPA
            },
            {
              path: "reglements",
              name: "Suivi des règlements",
              redirect: "reglements/list",
              meta: {title: 'Cotisations - Règlements'},
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              children: [
                {
                  path: "list",
                  name: "Recherche règlements",
                  meta: {cssClass:'espace-rpa', site: sites.RPA, title: 'Cotisations - Règlements'},
                  component: Reglements
                },
                {
                  path: "create-virement",
                  name: "Création virement",
                  meta: {cssClass:'espace-rpa', site: sites.RPA, title: 'Création virement '},
                  component: CreateVirement
                },
                {
                  path: "edit-reglement/:id",
                  name: "Modification du règlement",
                  meta: {cssClass:'espace-rpa', site: sites.RPA, title: 'Modification du règlement ',rule: espaceRPARules.MANAGE_RPA_DATA},
                  component: () => import("@/views/espaceRPA/reglements/EditReglement")
                }
              ]
            },
            {
              path: "soldes",
              name: "Historique des soldes",
              redirect: "",
              meta: {cssClass: 'espace-rpa', site: sites.RPA, title: 'Cotisations - Soldes'},
              component: Soldes
            },
            {
              path: "clotures",
              name: "Historique des clotures",
              redirect: "",
              meta: {cssClass: 'espace-rpa', site: sites.RPA, title: 'Cotisations - Clotures'},
              component: Clotures
            },
            {
              path: "mouvements",
              name: "Mouvements BRED",
              redirect: "",
              meta: {cssClass: 'espace-rpa', site: sites.RPA, title: 'Cotisations - Mouvements'},
              component: Mouvements
            },
            {
              path: "iban-siren",
              name: "Référentiel IBAN SIREN",
              redirect: "iban-siren/list",
              meta: {title: 'Cotisations - Référentiel'},
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              children: [
                {
                  path: "list",
                  name: "Recherche IBAN - SIREN",
                  meta: {cssClass:'espace-rpa', site: sites.RPA, title: 'Référentiel IBAN - SIREN'},
                  component: ReferentielIBANSIREN
                },
                {
                  path: "create",
                  name: "Création IBAN - SIREN",
                  meta: {cssClass:'espace-rpa', site: sites.RPA, title: 'Création IBAN - SIREN '},
                  component: CreateIBANSIREN
                }
              ]
            },

          ]
        },
        {
          path: "espace-beneficiaire",
          redirect: "/espace-beneficiaire/accueil",
          name: "Espace bénéficiaire",
          meta: {title: 'BO - Espace bénéficiaire'},
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "actualites",
              name: "Gestion des actualités",
              redirect: "actualites/list",
              meta: {title: 'BO - EB - Actualités'},
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              children: [
                {
                  path: "list",
                  name: "Liste des actualités",
                  meta: {cssClass:'espace-beneficiaire', rule: rulesEB.ACCESS_NEWS, site: sites.EB, title: 'BO - EB - Liste des actualités'},
                  component: Actualites
                },
                {
                  path: "edit/:id",
                  name: "Modifier une actualité",
                  meta: {cssClass:'espace-beneficiaire', rule: rulesEB.ACCESS_NEWS, site: sites.EB, title: 'BO - EB - Modification d\'une actualité'},
                  component: EditActualites
                },
                {
                  path: "add/",
                  name: "Créer une actualité",
                  meta: {cssClass:'espace-beneficiaire', rule: rulesEB.ACCESS_NEWS, site: sites.EB, title: 'BO - EB - Création d\'une actualité'},
                  component: AddActualites
                }
              ]
            },
            {
                path: "echeancier",
                name: "Gestion échéancier",
                redirect: "echeancier/index",
                meta: {title: 'BO - EB - Actualités'},
                component: {
                  render(c) {
                    return c("router-view");
                  }
                },
                children: [
                  {
                    path: "index",
                    name: "Modification écheancier",
                    meta: {cssClass:'espace-beneficiaire', rule: rulesEB.ACCESS_ECHEANCIER, site: sites.EB, title: 'BO - EB - Modification échéanier'},
                    component: EditEcheancier
                  }
                ]
              },
            {
              path: "beneficiaires",
              name: "Bénéficiaires",
              redirect: "beneficiaires/list",
              meta: {title: 'BO - EB - Echéancier'},
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              children: [
                {
                  path: "list",
                  name: "Liste des bénéficiaires",
                  meta: {cssClass:'espace-beneficiaire', rule: rulesEB.ACCESS_BENEFICIAIRES, site: sites.EB, title: 'BO - EB - Liste des bénéficiaires'},
                  component: Beneficiaires
                },
                {
                  path: "fiche/:id",
                  name: "Fiche",
                  meta: {cssClass:'espace-beneficiaire', rule: rulesEB.ACCESS_BENEFICIAIRES, site: sites.EB, title: 'BO - EB - Fiche du bénéficiaire'},
                  component: FicheBeneficiaire
                },
              ]
            },
            {
              path: "gestion-des-contacts",
              name: "Contacts",
              meta: {cssClass:'espace-beneficiaire', rule: rulesEB.ACCESS_CONTACTS, site: sites.EB, title: 'BO - EB - Contacts'},
              redirect: "gestion-des-contacts/list",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              children: [
                {
                  path: "list",
                  name: "Liste des contacts",
                  meta: {cssClass:'espace-beneficiaire', rule: rulesEB.ACCESS_CONTACTS, site: sites.EB, title: 'BO - EB - Liste des contacts'},
                  component: Contacts
                },
                {
                  path: ":id",
                  name: "Fiche de contact",
                  meta: {cssClass:'espace-beneficiaire', rule: rulesEB.ACCESS_CONTACTS, site: sites.EB, title: 'BO - EB - Détail du contact'},
                  component: FicheContact
                }
              ]
            },
            {
              path: "gestion-des-sujets",
              name: "Gestion des sujets",
              redirect: "gestion-des-sujets/list",
              meta: {title: 'BO - EB - Sujets'},
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              children: [
               {
                  path: "list/",
                  name: "Liste des Sujet",
                  meta: {cssClass:'espace-beneficiaire', rule: rulesEB.ACCESS_CONFIG_SUJETS, site: sites.EB, title: 'BO - Espace bénéficiaire - Contact'},
                  component: AdminContacts,
                },
                {
                  path: "add/",
                  name: "Créer un Sujet",
                  meta: {cssClass:'espace-beneficiaire', rule: rules.ACCESS_CONFIG_SUJETS, site: sites.EB, title: 'BO - EB - Création d\'un sujet'},
                  component: AddAdminContacts
                },
                {
                  path: "edit/:id",
                  name: "Modifier un Sujet",
                  meta: {cssClass:'espace-beneficiaire', rule: rules.ACCESS_CONFIG_SUJETS, site: sites.EB, title: 'BO - EB - Modification du sujet'},
                  component: EditAdminContacts
                },
              ]
            },
            {
                path: "gestion-des-faq",
                name: "Gestion des FAQ",
                redirect: "gestion-des-faq/list",
                meta: {title: 'BO - EB - FAQ'},
                component: {
                  render(c) {
                    return c("router-view");
                  }
                },
                children: [
                 {
                    path: "list/",
                    name: "Liste des FAQ",
                    meta: {cssClass:'espace-beneficiaire', rule: rulesEB.ACCESS_FAQ, site: sites.EB, title: 'BO - Espace bénéficiaire - FAQ'},
                    component: AdminFaq,
                  },
                  {
                    path: "add/",
                    name: "Créer une FAQ",
                    meta: {cssClass:'espace-beneficiaire', rule: rules.MANAGE_FAQ, site: sites.EB, title: 'BO - EB - Création d\'une FAQ'},
                    component: AddAdminFaq
                  },
                  {
                    path: "edit/:id",
                    name: "Modifier une FAQ",
                    meta: {cssClass:'espace-beneficiaire', rule: rules.MANAGE_FAQ, site: sites.EB, title: 'BO - EB - Modification du FAQ'},
                    component: EditAdminFaq
                  },
                ]
              },
            {
              path: "justificatifs",
              name: "Justificatifs",
              meta: {title: 'BO - EB - Justificatifs'},
              redirect: "justificatifs/list",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              children: [
                {
                  path: "list",
                  name: "Liste des justificatifs",
                  meta: {cssClass:'espace-beneficiaire', rule: rulesEB.ACCESS_JUSTIFICATIFS, site: sites.EB, title: 'BO - EB - Liste des justificatifs'},
                  component: Justificatifs
                },
                {
                  path: ":id",
                  name: "Fiche de dossier",
                  meta: {cssClass:'espace-beneficiaire', rule: rulesEB.ACCESS_JUSTIFICATIFS, site: sites.EB, title: 'BO - EB - Détails du dossier'},
                  component: FicheDossier
                }
              ]
            },
            {
              path: "gestion-des-decomptes",
              name: "Decomptes",
              meta: {cssClass:'espace-beneficiaire', rule: rulesEB.ACCESS_DECOMPTES, site: sites.EB, title: 'BO - EB - Décomptes'},
              component: Decomptes
            },
            {
              path: "statistiques",
              name: "Statistiques",
              meta: {title: 'BO - Espace bénéficiaire'},
              redirect: "statistiques/contacts",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              children: [
                {
                  path: "contacts",
                  name: "Statistiques Contacts",
                  meta: {cssClass:'espace-beneficiaire', rule: rulesEB.ACCESS_STATS, site: sites.EB, title: 'BO - EB - Statistiques'},
                  component: Statistiques
                }
              ]
            },
            // {
            //   path: "statistiques",
            //   name: "Statistiques",
            //   meta: {title: 'BO - Espace bénéficiaire'},
            //   redirect: "statistiques/foire-aux-questions",
            //   component: {
            //     render(c) {
            //       return c("router-view");
            //     }
            //   },
            //   children: [
            //     {
            //       path: "foire-aux-questions",
            //       name: "Foire aux questions",
            //       meta: {cssClass:'espace-beneficiaire', rule: rulesEB.ACCESS_STATS, site: sites.EB, title: 'BO - EB - Statistiques FAQ'},
            //       component: FaqStats
            //     }
            //   ]
            // },
            {
              path: "inscriptions",
              name: "Inscriptions",
              meta: {cssClass:'espace-beneficiaire', rule: rulesEB.ACCESS_INSCRIPTIONS, site: sites.EB, title: 'BO - EB - Inscriptions'},
              component: Inscriptions
            }
          ]
        },
        {
          path: "/administration",
          redirect: "administration/accueil",
          name: "Administration",
          meta: {title: 'Administration'},
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "compte-user",
              name: "Mon compte",
              meta: {cssClass:'accueil', site: sites.SETTINGS, title: 'BO - Mon compte'},
              component: MonCompte
            },
            {
              path: "notification-user/:type",
              name: "Mes notifications",
              meta: {cssClass:'accueil', site: sites.SETTINGS, title: 'BO - Mes notifications'},
              component: () => import("@/views/users/Notifications"),
            },
            {
              path: "change-passwd",
              name: "Changer mot de passe",
              meta: {cssClass:'accueil', site: sites.SETTINGS, title: 'BO - Changement de mot de passe'},
              component: ChangePasswd
            },
            {
                path: "accueil",
                name: "Page d'accueil",
                meta: {cssClass:'accueil', site: sites.SETTINGS, title: 'BO - Page d\'accueil'},
                component: AccueilAdmin
            },
            {
              path: "parametrage",
              name: "Paramétrage des tables",
              redirect: "delegation",
              meta: {title: 'Administration - Droits'},
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              children: [
                {
                  path: "delegation",
                  name: "Paramétrage des Délégations commerciales",
                  meta: {cssClass:'accueil', rule: rules.ACCESS_ADMIN_TABLE_TRANSVERSE, site: sites.SETTINGS, title: 'Administration - Délégation'},
                  component: DelegationCommerciale
                },
                {
                  path: "delegationTerritoriale",
                  name: "Paramétrage des Délégations territoriales",
                  meta: {cssClass:'accueil', rule: rules.ACCESS_ADMIN_TABLE_TRANSVERSE, site: sites.SETTINGS, title: 'Administration - Délégation Territoriale'},
                  component: DelegationTerritoriale
                },
                {
                  path: "segmentCommercial",
                  name: "Paramétrage des segments commerciaux",
                  meta: {cssClass:'accueil', rule: rules.ACCESS_ADMIN_TABLE_TRANSVERSE, site: sites.SETTINGS, title: 'Administration - Segment Commercial'},
                  component: SegmentCommercial
                },
                {
                  path: "prestij",
                  name: "Paramétrage des statuts Prest'IJ",
                  meta: {cssClass:'accueil', rule: rules.ACCESS_ADMIN_TABLE_TRANSVERSE, site: sites.SETTINGS, title: 'Administration - Table PrestIJ'},
                  component: StatusPrestij
                },
                {
                  path: "codePostal",
                  name: "Paramétrage des codes postaux",
                  meta: {cssClass:'accueil', rule: rules.ACCESS_ADMIN_TABLE_TRANSVERSE,site: sites.SETTINGS, title: 'Administration - Codes Postaux'},
                  component: CodePostal
                },
              ]
            },
            {
              path: "rules",
              name: "Gestion des droits",
              redirect: "rules/list",
              meta: {title: 'Administration - Droits'},
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              children: [
                {
                  path: "list",
                  name: "Liste des droits",
                  meta: {cssClass:'accueil', rule: rules.ACCESS_ADMIN_GLOBAL, site: sites.SETTINGS, title: 'Administration - Droits'},
                  component: RulesManagement
                },
                {
                  path: "edit/:id",
                  name: "Modifier Droit",
                  meta: {cssClass:'accueil', rule: rules.ACCESS_ADMIN_GLOBAL,site: sites.SETTINGS, title: 'Administration - Droits'},
                  component: EditDroit
                },
                {
                  path: "add/",
                  name: "Créer un Droit",
                  meta: {cssClass:'accueil', rule: rules.ACCESS_ADMIN_GLOBAL,site: sites.SETTINGS, title: 'Administration - Droits'},
                  component: AddDroit
                }
              ]
            },
            {
              path: "users",
              name: "Gestion des utilisateurs",
              redirect: "users/list",
              meta: {title: 'Administration - User'},
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              children: [
                {
                  path: "list",
                  name: "Liste des utilisateurs",
                  meta: {cssClass:'accueil', rule: rules.ACCESS_ADMIN_GLOBAL,site: sites.SETTINGS, title: 'Administration - Utilisateurs'},
                  component: GestionUsers
                },
                {
                  path: "edit/:id",
                  name: "Modifier un utilisateur",
                  meta: {cssClass:'accueil', rule: rules.ACCESS_ADMIN_GLOBAL, site: sites.SETTINGS, title: 'Administration - Utilisateurs'},
                  component: EditUser
                },
                {
                  path: "add/",
                  name: "Créer un utilisateur",
                  meta: {cssClass:'accueil', rule: rules.ACCESS_ADMIN_GLOBAL, site: sites.SETTINGS, title: 'Administration - Utilisateurs'},
                  component: CreateUser
                },
              ]
            },
            {
              path: "profiles",
              name: "Gestion des profils",
              redirect: "profiles/list",
              meta: {title: 'Administration - Profils'},
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              children: [
                {
                  path: "list",
                  name: "Liste des profils",
                  meta: {cssClass:'accueil', rule: rules.ACCESS_ADMIN_GLOBAL, site: sites.SETTINGS, title: 'Administration - Profils'},
                  component: GestionProfils
                },
                {
                  path: "edit/:id",
                  name: "Modifier un profil",
                  meta: {cssClass:'accueil', rule: rules.ACCESS_ADMIN_GLOBAL, site: sites.SETTINGS, title: 'Administration - Profils'},
                  component: EditProfil
                },
                {
                  path: "add/",
                  name: "Créer un profil",
                  meta: {cssClass:'accueil', rule: rules.ACCESS_ADMIN_GLOBAL, site: sites.SETTINGS, title: 'Administration - Profils'},
                  component: CreateProfil
                }
              ]
            },
            {
              path: "rapports",
              name: "Gestion des rapports",
              redirect: "rapports/list",
              meta: {title: 'Administration - Rapports'},
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              children: [
                {
                  path: "list",
                  name: "Liste des rapports",
                  meta: {cssClass:'accueil', rule: rules.CAN_MANAGE_REPORTS, site: sites.SETTINGS, title: 'Administration - Rapports'},
                  component: GestionRapport
                },
                {
                  path: "edit/:id",
                  name: "Modifier un rapport",
                  meta: {cssClass:'accueil', rule: rules.CAN_EDIT_REPORT, site: sites.SETTINGS, title: 'Administration - Rapports'},
                  component: EditRapport
                },
                {
                  path: "add/",
                  name: "Créer un rapport",
                  meta: {cssClass:'accueil', rule: rules.CAN_CREATE_REPORT, site: sites.SETTINGS, title: 'Administration - Rapports'},
                  component: CreateRapport
                }
              ]
            },
            {
              path: "traitements",
              name: "Gestion des traitements",
              redirect: "traitements/list",
              meta: {title: 'Administration - Traitements'},
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              children: [
                {
                  path: "list",
                  name: "Liste des traitements",
                  meta: {cssClass:'accueil', rule: rules.ACCESS_ADMIN_GLOBAL, site: sites.SETTINGS, title: 'Administration - Traitements'},
                  component: GestionTraitement
                },
                {
                  path: "edit/:id",
                  name: "Modifier un traitement",
                  meta: {cssClass:'accueil', rule: rules.ACCESS_ADMIN_GLOBAL, site: sites.SETTINGS, title: 'Administration - Traitements'},
                  component: EditTraitement
                },
                {
                  path: "add/",
                  name: "Créer un traitement",
                  meta: {cssClass:'accueil', rule: rules.ACCESS_ADMIN_GLOBAL, site: sites.SETTINGS, title: 'Administration - Traitements'},
                  component: CreateTraitement
                }
              ]
            },
            {
              path: "bal",
              name: "Gestion des BAL",
              redirect: "bal/list",
              meta: {title: 'Administration - BAL'},
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              children: [
                {
                  path: "list",
                  name: "Liste des BAL",
                  meta: {cssClass:'accueil', rule: rules.ACCESS_ADMIN_GLOBAL, site: sites.SETTINGS, title: 'Administration - des BAL'},
                  component: GestionBal
                },
              ]
            },
            {
              path: "categories",
              name: "Gestion des catégories",
              redirect: "categories/list",
              meta: {title: 'Administration'},
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              children: [
                {
                  path: "list",
                  name: "Liste des catégories",
                  meta: {cssClass:'accueil', rule: rules.ACCESS_ADMIN_GLOBAL, site: sites.SETTINGS},
                  component: GestionStatus
                },
                {
                  path: "add/",
                  name: "Créer une catégorie",
                  meta: {cssClass:'accueil', rule: rules.ACCESS_ADMIN_GLOBAL, site: sites.SETTINGS, title: 'Administration - Catégories'},
                  component: CreateCategorie
                },
                {
                  path: "edit/:id",
                  name: "Modifier une catégorie",
                  meta: {cssClass:'accueil', rule: rules.ACCESS_ADMIN_GLOBAL, site: sites.SETTINGS, title: 'Administration - Catégories'},
                  component: EditCategorie
                }
              ]
            },
            {
              path: "statuts",
              name: "Gestion des statuts",
              redirect: "statuts/list",
              meta: {title: 'Administration'},
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              children: [
                {
                  path: "list",
                  name: "Liste des statuts",
                  meta: {cssClass:'accueil', rule: rules.ACCESS_ADMIN_GLOBAL, site: sites.SETTINGS, title: 'Administration - Statuts'},
                  component: GestionStatus
                },
                {
                  path: "add/",
                  name: "Créer un status",
                  meta: {cssClass:'accueil', rule: rules.ACCESS_ADMIN_GLOBAL, site: sites.SETTINGS, title: 'Administration - Statuts'},
                  component: CreateStatus
                },
                {
                  path: "edit/:id",
                  name: "Modifier un statut",
                  meta: {cssClass:'accueil', rule: rules.ACCESS_ADMIN_GLOBAL, site: sites.SETTINGS, title: 'Administration - Statuts'},
                  component: EditStatus
                }
              ]
            },
            {
              path: "espaces",
              name: "Gestion des espaces",
              redirect: "espaces/list",
              meta: {title: 'Administration - Espaces'},
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              children: [
                {
                  path: "list",
                  name: "Liste des espaces",
                  meta: {cssClass:'accueil', rule: rules.ACCESS_ADMIN_GLOBAL, site: sites.SETTINGS, title: 'Administration - Espaces'},
                  component: () => import("@/views/administration/espaces/GestionEspace"),
                },
                {
                  path: "edit/:id",
                  name: "Modifier un espace",
                  meta: {cssClass:'accueil', rule: rules.ACCESS_ADMIN_GLOBAL, site: sites.SETTINGS, title: 'Administration - Espaces'},
                  component: () => import("@/views/administration/espaces/EditEspace"),
                },
                {
                  path: "add",
                  name: "Créer un espace",
                  meta: {cssClass:'accueil', rule: rules.ACCESS_ADMIN_GLOBAL, site: sites.SETTINGS, title: 'Administration - Espaces'},
                  component: () => import("@/views/administration/espaces/CreateEspace"),
                }
              ]
            },
            {
              path: "modules",
              name: "Gestion des modules",
              redirect: "modules/list",
              meta: {title: 'Administration - Modules'},
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              children: [
                {
                  path: "list",
                  name: "Liste des modules",
                  meta: {cssClass:'accueil', rule: rules.ACCESS_ADMIN_GLOBAL, site: sites.SETTINGS, title: 'Administration - Modules'},
                  component: () => import("@/views/administration/modules/GestionModule"),
                },
                {
                  path: "edit/:id",
                  name: "Modifier un module",
                  meta: {cssClass:'accueil', rule: rules.ACCESS_ADMIN_GLOBAL, site: sites.SETTINGS, title: 'Administration - Modules'},
                  component: () => import("@/views/administration/modules/EditModule"),
                },
                {
                  path: "add/",
                  name: "Créer un module",
                  meta: {cssClass:'accueil', rule: rules.ACCESS_ADMIN_GLOBAL, site: sites.SETTINGS, title: 'Administration - Modules'},
                  component: () => import("@/views/administration/modules/CreateModule"),
                }
              ]
            },
            {
              path: "operations",
              name: "Gestion des opérations",
              redirect: "operations/list",
              meta: {title: 'Administration'},
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              children: [
                {
                  path: "list",
                  name: "Liste des opérations",
                  meta: {cssClass:'accueil', rule: rules.ACCESS_ADMIN_GLOBAL, site: sites.SETTINGS, title: 'Administration - Fil des Opérations'},
                  component: TraceNavigation
                }
              ]
            },
            {
              path: "structures",
              name: "Gestion des structures",
              redirect: "structures/list",
              meta: {title: 'Administration - Structures'},
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              children: [
                {
                  path: "list",
                  name: "Liste des structures",
                  meta: {cssClass:'accueil', rule: rules.MANAGE_STRUCTURES, site: sites.SETTINGS, title: 'Administration - Structures'},
                  component: () => import("@/views/administration/structures/List"),
                },
                {
                  path: "edit/:id",
                  name: "Modifier une structure",
                  meta: {cssClass:'accueil', rule: rules.MANAGE_STRUCTURES, site: sites.SETTINGS, title: 'Administration - Structures'},
                  component: () => import("@/views/administration/structures/Edit"),
                },
                {
                  path: "add/",
                  name: "Créer une structure",
                  meta: {cssClass:'accueil', rule: rules.MANAGE_STRUCTURES, site: sites.SETTINGS, title: 'Administration - Structures'},
                  component: () => import("@/views/administration/structures/Add"),
                }
              ]
            },
            {
              path: "monitoring",
              name: "Gestion de monitoring",
              redirect: "monitoring/list-cron",
              meta: {title: 'Administration'},
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              children: [
                {
                  path: "list-cron",
                  name: "Tâches planifiées",
                  meta: {cssClass:'accueil', rule: rules.ACCESS_ADMIN_MONITORING, site: sites.SETTINGS, title: 'Administration - Monitoring'},
                  component: () => import("@/views/administration/monitoring/Cron"),
                },
                {
                  path: "list-users",
                  name: "Monitoring Utilisateurs",
                  meta: {cssClass:'accueil', rule: rules.ACCESS_ADMIN_MONITORING, site: sites.SETTINGS, title: 'Administration - Monitoring'},
                  component: () => import("@/views/administration/monitoring/ActiveUsers"),
                },
                {
                  path: "grafana",
                  name: "Grafana",
                  meta: {cssClass:'accueil', rule: rules.ACCESS_ADMIN_MONITORING, site: sites.SETTINGS, title: 'Administration - Grafana'},
                  component: () => import("@/views/administration/monitoring/Grafana"),
                },
              ]
            },
            {
              path: "astuces",
              name: "Gestion des astuces",
              redirect: "astuces/list",
              meta: {title: 'Administration'},
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              children: [
                {
                  path: "list",
                  name: "Liste des astuces",
                  meta: {cssClass:'accueil', rule: rules.ACCESS_ASTUCES, site: sites.SETTINGS, title: 'Administration - Gestion Astuces'},
                  component: () => import("@/views/administration/astuces/List")
                },
                {
                  path: "add",
                  name: "Créer une astuce",
                  meta: {cssClass:'accueil', rule: rules.MANAGE_ASTUCES, site: sites.SETTINGS, title: 'Administration - Gestion Astuces'},
                  component: () => import("@/views/administration/astuces/Add")
                },
                {
                  path: "edit/:id",
                  name: "Modifier une astuce",
                  meta: {cssClass:'accueil', rule: rules.MANAGE_ASTUCES, site: sites.SETTINGS, title: 'Administration - Gestion Astuces'},
                  component: () => import("@/views/administration/astuces/Edit")
                }
              ]
            },
            {
              path: "/administration/gestionOapOag/oag",
              name: "Gestion des OAG",
              redirect: "/administration/gestionOapOag/oag/list",
              meta: {title: 'Administration'},
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              children: [
                {
                  path: "list",
                  name: "Liste des codes OAG",
                  meta: {cssClass:'accueil', rule: rules.MANAGE_OAP_OAG, site: sites.SETTINGS, title: 'Administration - Gestion OAG'},
                  component: () => import("@/views/administration/gestionOapOag/oag/List")
                },
                {
                  path: "create",
                  name: "Créer un code OAG",
                  meta: {cssClass:'accueil', rule: rules.MANAGE_OAP_OAG, site: sites.SETTINGS, title: 'Administration - Creéation OAG'},
                  component: () => import("@/views/administration/gestionOapOag/oag/Create")
                },
                {
                  path: "edit/:id",
                  name: "Modifier un code OAG",
                  meta: {cssClass:'accueil', rule: rules.MANAGE_OAP_OAG, site: sites.SETTINGS, title: 'Administration - Modification OAG'},
                  component: () => import("@/views/administration/gestionOapOag/oag/Edit")
                }
              ]
            },
            {
              path: "/administration/gestionOapOag/oap",
              name: "Gestion des OAP",
              redirect: "/administration/gestionOapOag/oap/list",
              meta: {title: 'Administration'},
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              children: [
                {
                  path: "list",
                  name: "Liste des codes OAP",
                  meta: {cssClass:'accueil', rule: rules.MANAGE_OAP_OAG, site: sites.SETTINGS, title: 'Administration - Gestion OAP'},
                  component: () => import("@/views/administration/gestionOapOag/oap/List")
                },
                {
                  path: "create",
                  name: "Créer un code OAP",
                  meta: {cssClass:'accueil', rule: rules.MANAGE_OAP_OAG, site: sites.SETTINGS, title: 'Administration - Creéation OAP'},
                  component: () => import("@/views/administration/gestionOapOag/oap/Create")
                },
                {
                  path: "edit/:id",
                  name: "Modifier un code OAP",
                  meta: {cssClass:'accueil', rule: rules.MANAGE_OAP_OAG, site: sites.SETTINGS, title: 'Administration - Modification OAP'},
                  component: () => import("@/views/administration/gestionOapOag/oap/Edit")
                }
              ]
            },
            {
              path: "/administration/gestionFichiers",
              name: "Gestion des Fichiers",
              meta: { 
                cssClass: 'accueil', 
                rule: rules.CAN_ACCESS_UPLOAD_FILE_INTERFACE,
                site: sites.SETTINGS, 
                title: 'Administration - Gestion Fichiers SFTP' 
              },
              component: () => import("@/views/administration/gestionFichiers/Index")
            },
            {
              path: "livraisons",
              name: "Gestion des livraisons",
              redirect: "livraisons/list",
              meta: {title: 'Administration'},
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              children: [
                {
                  path: "list",
                  name: "Liste des livraisons",
                  meta: {cssClass:'accueil', rule: rules.CAN_ACCESS_LIVRAISONS, site: sites.SETTINGS, title: 'Administration - Suivis des livraisons'},
                  component: ListeLivraisons
                },
                {
                  path: "edit/:id",
                  name: "Modifier une livraison",
                  meta: {cssClass:'accueil', rule: rules.CAN_MANAGE_LIVRAISONS, site: sites.SETTINGS, title: 'Administration - Suivis des livraisons'},
                  component: () => import("@/views/administration/livraisons/Edit"),
                },
                {
                  path: "add/",
                  name: "Créer une livraison",
                  meta: {cssClass:'accueil', rule: rules.CAN_MANAGE_LIVRAISONS, site: sites.SETTINGS, title: 'Administration - Suivis des livraisons'},
                  component: () => import("@/views/administration/livraisons/Add"),
                },
                {
                  path: "show/:id",
                  name: "Détails de la livraison",
                  meta: {cssClass:'accueil', site: sites.SETTINGS, title: 'Administration - Suivis des livraisons'},
                  component: () => import("@/views/administration/livraisons/Show"),
                },
              ]
            },
            // {
            //   path: "last-versions",
            //   name: "Histo livraisons",
            //   redirect: "last-versions/list",
            //   meta: {title: 'Administration'},
            //   component: {
            //     render(c) {
            //       return c("router-view");
            //     }
            //   },
            //   children: [
            //     {
            //       path: "list",
            //       name: "Histo livraisons",
            //       meta: {cssClass:'accueil', rule: rules.CAN_ACCESS_LIVRAISONS, site: sites.SETTINGS, title: 'Administration - Suivis des livraisons'},
            //       component: LastVersions
            //     },
            //   ]
            // },
          ]
        },
        {
          path: "/espace-qualite",
          redirect: "espace-qualite/accueil",
          name: "Espace Qualité",
          meta: {title: 'Espace Qualité'},
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "accueil",
              name: "Page d'accueil espace qualité",
              meta: {cssClass:'espace-qualite', site: sites.EC, title: 'Espace Contrôle - Page d\'accueil'},
              component: () => import("@/views/espaceQualite/Accueil"),
            },
            {
              path: "campagnes",
              name: "Gestion des campagnes",
              redirect: "campagnes/list",
              meta: {cssClass:'espace-qualite', site: sites.EC, title: 'Espace Qualité - Campagnes', rule: espaceQualiteRules.ACCESS_CAMPAGNES},
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              children: [
                {
                  path: "list",
                  name: "Liste des campagnes",
                  meta: {cssClass:'espace-qualite', site: sites.EC, title: 'Espace Contrôle - Campagnes', rule: espaceQualiteRules.ACCESS_CAMPAGNES},
                  component: () => import("@/views/espaceQualite/campagnes/GestionCampagnes")
                },
                {
                  path: "detail/:id",
                  name: "Détail Campagne",
                  meta: {cssClass:'espace-qualite', site: sites.EC, title: 'Espace Contrôle - Campagnes', rule: espaceQualiteRules.ACCESS_CAMPAGNES},
                  component: () => import("@/views/espaceQualite/campagnes/Detail")
                },
                {
                  path: "add",
                  name: "Créer une Campagne",
                  meta: {cssClass:'espace-qualite', site: sites.EC, title: 'Espace Contrôle - Campagnes', rule: espaceQualiteRules.ACCESS_CAMPAGNES},
                  component: () => import("@/views/espaceQualite/campagnes/Add")
                },
                {
                  path: "attacher-dossiers/:id",
                  name: "Attacher Dossier(s)",
                  meta: {cssClass:'espace-qualite', site: sites.EC, title: 'Espace Contrôle - Attacher Dossiers', rule: espaceQualiteRules.ACCESS_CAMPAGNES},
                  component: () => import("@/views/espaceQualite/campagnes/AttachDossiers")
                },
                {
                  path: "motifs-non-conforme/:id",
                  name: "Motifs Non Conforme",
                  meta: {cssClass:'espace-qualite', site: sites.EC, title: 'Espace Contrôle - Motifs Non Conforme', rule: espaceQualiteRules.ACCESS_CAMPAGNES},
                  component: () => import("@/views/espaceQualite/campagnes/MotifsNonConforme")
                },
                {
                  path: "rapport-collaborateur/:id",
                  name: "Rapport Collaborateur",
                  meta: {cssClass:'espace-qualite', site: sites.EC, title: 'Espace Contrôle - Rapport Collaborateur', rule: espaceQualiteRules.ACCESS_CAMPAGNES},
                  component: () => import("@/views/espaceQualite/campagnes/RapportCollaborateur")
                },
              ]
            },
            {
              path: "controle-qualite",
              name: "Gestion Dossiers",
              redirect: "controle-qualite/campagnes-actives",
              meta: {cssClass:'espace-qualite', title: 'Espace Qualité - Gestion dossiers'},
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              children: [
                {
                  path: "campagnes-actives",
                  name: "Liste des campagnes actives",
                  meta: {cssClass:'espace-qualite', site: sites.EC, title: 'Espace Qualité - Gestion dossiers', rule: espaceQualiteRules.MANAGE_CONTROLE_QUALITE},
                  component: () => import("@/views/espaceQualite/controle-qualite/CorbeillesCampagne")
                },
                {
                  path: "dossier/show/:id",
                  name: "fiche dossier qualité",
                  meta: {cssClass: 'espace-qualite', site: sites.EC, title: 'Visualisation du dossier', rule: espaceQualiteRules.MANAGE_CONTROLE_QUALITE},
                  component: () => import("@/views/espaceGestion/GestionDossier/Dossier")
                }
              ]
            },
          ]
        },
        {
          path: "/espace-bibliotheque",
          redirect: "espace-bibliotheque/accueil",
          name: "Espace Bibliothèque",
          meta: {title: 'Espace Bibliothèque', cssClass:'espace-bibliotheque'},
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "accueil",
              name: "Page d'accueil Espace Bibliothèque",
              meta: {cssClass:'espace-bibliotheque', site: sites.EBIBLIO, title: 'Espace Bibliothèque - Page d\'accueil', rule: espaceBibliothequeRules.CAN_ACCESS_BIBLIOTHEQUE},
              component: () => import("@/views/espaceBibliotheque/Accueil"),
            },
            {
              path: "accueil/familleProduit/:familleProduitId",
              name: "Accueil Bibliothèque produit",
              meta: {cssClass:'espace-bibliotheque', site: sites.EBIBLIO, title: 'Espace Bibliothèque - Page d\'accueil', rule: espaceBibliothequeRules.CAN_ACCESS_BIBLIOTHEQUE},
              component: () => import("@/views/espaceBibliotheque/Accueil"),
            },
            {
              path: "epargne-retraite",
              name: "Bibliothèque - Epargne / Retraite",
              meta: {cssClass:'espace-bibliotheque', site: sites.EBIBLIO, title: 'Espace Bibliothèque - Epargne / Retraite', rule: espaceBibliothequeRules.CAN_ACCESS_BIBLIOTHEQUE},
              component: () => import("@/views/espaceBibliotheque/EpargneRetraite")
            },
            {
              path: "documents",
              name: "Bibliothèque",
              redirect: "documents/admin",
              meta: {cssClass:'espace-bibliotheque', site: sites.EBIBLIO, title: 'Espace Bibliothèque - Documents', rule: espaceBibliothequeRules.CAN_ACCESS_BIBLIOTHEQUE},
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              children: [
                {
                  path: "admin",
                  name: "Gestion des documents",
                  meta: {cssClass:'espace-bibliotheque', site: sites.EBIBLIO, title: 'Espace Bibliothèque - Documents', rule: espaceBibliothequeRules.CAN_MANAGE_BIBLIOTHEQUE},
                  component: () => import("@/views/espaceBibliotheque/documents/Documents")
                }
              ]
            },
            {
              path: "document/video/:id",
              name: "Gestion des documents vidéo",
              meta: {cssClass:'espace-bibliotheque', site: sites.EBIBLIO, title: 'Espace Bibliothèque - Vidéo', rule: espaceBibliothequeRules.CAN_MANAGE_BIBLIOTHEQUE},
              component: () => import("@/components/Bibliotheque/Document/DocumentVideo")
            },
            {
              path: "categorie",
              name: "Gestion des catégories de document",
              meta: {cssClass:'espace-bibliotheque', site: sites.EBIBLIO, title: 'Espace Bibliothèque - Catégorie', rule: espaceBibliothequeRules.CAN_MANAGE_CATEGORIE},
              component: () => import("@/views/espaceBibliotheque/parametrage/Categorie"),
            },
            {
              path: "sous-categorie",
              name: "Gestion des sous-catégories de document",
              meta: {cssClass:'espace-bibliotheque', site: sites.EBIBLIO, title: 'Espace Bibliothèque - Sous-Categorie', rule: espaceBibliothequeRules.CAN_MANAGE_CATEGORIE},
              component: () => import("@/views/espaceBibliotheque/parametrage/SousCategorie"),
            },
            {
              path: "type-document",
              name: "Gestion des types de document",
              meta: {cssClass:'espace-bibliotheque', site: sites.EBIBLIO, title: 'Espace Bibliothèque - Type', rule: espaceBibliothequeRules.CAN_MANAGE_TYPE},
              component: () => import("@/views/espaceBibliotheque/parametrage/Type"),
            },
            {
              path: "rubrique",
              name: "Gestion des rubriques de document",
              meta: {cssClass:'espace-bibliotheque', site: sites.EBIBLIO, title: 'Espace Bibliothèque - Rubrique', rule: espaceBibliothequeRules.CAN_MANAGE_RUBRIQUE},
              component: () => import("@/views/espaceBibliotheque/parametrage/Rubrique"),
            },
            {
              path: "sous-rubrique",
              name: "Gestion des sous-rubriques de document",
              meta: {cssClass:'espace-bibliotheque', site: sites.EBIBLIO, title: 'Espace Bibliothèque - Sous-Rubrique', rule: espaceBibliothequeRules.CAN_MANAGE_RUBRIQUE},
              component: () => import("@/views/espaceBibliotheque/parametrage/SousRubrique"),
            },
          ]
        },
        {
          path: "espace-employeur",
          redirect: "/espace-employeur/accueil",
          name: "Espace Employeur",
          meta: { title: 'Espace Employeur' },
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "accueil",
              name: "Page d'accueil Espace Employeur",
              meta: {cssClass:'espace-employeur', site: sites.EEM, title: 'Espace Employeur - Page d\'accueil'},
              component: AccueilEspaceEmployeur,
            },
            {
              path: "affectation-sm",
              name: "Affectation grille CeV",
              meta: {cssClass:'espace-employeur', site: sites.EEM, title: 'Espace Employeur - Affectation grille CeV'},
              component: AffectationGrille,
            },
            {
              path: "inscription-cev",
              name: "Inscription CeV",
              meta: {cssClass:'espace-employeur', site: sites.EEM, title: 'Espace Employeur - Inscription CeV'},
              component: Inscription,
            },
            {
              path: "inscription-cev/saisie-siret",
              name: "Inscription CeV siret",
              meta: {cssClass:'espace-employeur', site: sites.EEM, title: 'Espace Employeur - Inscription CeV'},
              component: GenerateCodeAccess,
            },
            {
              path: "edit/admin",
              name: "Changement administrateur",
              meta: {cssClass:'espace-employeur', site: sites.EEM, title: 'Espace Employeur - Changement administrateur'},
              component: AdminSearch,
            },
            {
              path: "edit/siret",
              name: "Changement raison sociale",
              meta: {cssClass:'espace-employeur', site: sites.EEM, title: 'Espace Employeur - Changement raison sociale'},
              component: SiretSearch,
            },
          ]
        },
        {
          path: "espace-rc",
          redirect: "/espace-rc/fiches-niveau2",
          name: "Espace Relation Client",
          meta: { title: 'Espace Relation Client' },
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            // {
            //   path: "accueil",
            //   name: "Page d'accueil Espace Relation Client",
            //   meta: { cssClass: 'espace-rc', site: sites.ERC, title: 'Espace Relation Client - Page d\'accueil' },
            //   component: AccueilEspaceRC,
            // },
            {
              path: "fiches-niveau2",
              name: "Fiches Niveau 2 en cours",
              meta: {cssClass:'espace-rc', site: sites.ERC, title: 'Espace Relation Client - Fiches Niveau 2 en cours'},
              component: () => import("@/views/espaceRelationClient/ficheNiveau2/FichesEnCours") //component: FichesEnCours,
            },
            {
              path: "fiches-niv2/liste",
              name: "Recherche Fiches",
              meta: {cssClass:'espace-rc', site: sites.ERC, title: 'Espace Relation Client - Recherche Fiches'},
              component: () => import("@/views/espaceRelationClient/ficheNiveau2/Recherche"),
            },
            {
              path: "fiches/domaines/list",
              name: "Gestion Domaines",
              meta: {cssClass:'espace-rc', site: sites.ERC, title: 'Espace Relation Client - Gestion Domaines'},
              component: () => import("@/views/espaceRelationClient/domaine/Domaines"),
            },
            {
              path: "fiches/domaine-equipe",
              name: "Domaine/Equipe",
              meta: {cssClass:'espace-rc', site: sites.ERC, title: 'Espace Relation Client - Domaine/Equipe'},
              component: () => import("@/views/espaceRelationClient/domaine/DomaineEquipe"),
            },
            {
              path: "fiche/add",
              name: "Création fiche",
              meta: {cssClass:'espace-rc', site: sites.ERC, title: 'Espace Relation Client - Création fiche'},
              component: () => import("@/views/espaceRelationClient/ficheNiveau2/Add"),
            },
            {
              path: "fiche/show/:id",
              name: "Modification fiche",
              meta: {cssClass:'espace-rc', site: sites.ERC, title: 'Espace Relation Client - Modification fiche'},
              component: () => import("@/views/espaceRelationClient/ficheNiveau2/Edit"),
            },
          ]
        },
        {
          path: "en-tant-que",
          name: "Se connecter en tant que",
          meta: {cssClass:'administration', site: sites.SETTINGS, title: 'Se Connecter En Tant Que'},
          component: () => import("@/components/LoginAs")
        },
        {
          path: "recherche/nir/:nir",
          name: "Recherche NIR",
          meta: { cssClass: '', site: '', title: 'BO - EG - Recherche NIR', slug: 'recherche_nir'},
          component: () => import("@/views/recherche/RechercheParNir"),
        },
      ]
    },
    { path: "*", component: Page404 }
  ]
});

router.beforeEach((to, from, next) => {
  if (to.meta.title != undefined) { document.title = to.meta.title; }

  setCurrentSite(to.meta.site)
  // Gestion de la redirection si pas logué
  // console.log('to.fullPath',to.fullPath)
  if(to.matched.some(record => record.meta && record.meta.requiresAuth === false)) {
    next();
  } else {
    requireAuth(to, from, next);
    // if (store.getters.isAuthenticated) {
    //   next()
    //   return
    // }
    // next('/login')
  }
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  // const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);
  // console.log(to.meta.title);
  // // If a route with a title was found, set the document (page) title to that value.
  // if(nearestWithTitle) document.title = nearestWithTitle.meta.title;

  /*if(to.meta.slug === 'recherche_nir' || from.meta.slug === 'recherche_nir') {
    to.meta.cssClass = from.meta.cssClass;
    to.meta.site = from.meta.site;
  }*/


  // if(to.meta.rule != undefined){
  //   if(hasRule(to.meta.rule)) {
  //       next()
  //   }else{
  //     alert('Vous n\'avez pas le droit d\'accéder à cette page.')
  //   //   next({
  //   //   path: "/",
  //   //   query: { redirect: to.fullPath }
  //   // });
  //   }
  // }else{
  //   next()
  // }
});

export default router
